import { put, call, all, fork, select, takeLatest } from "redux-saga/effects";
import { isEmpty } from "lodash";

import { transfersByUsersProvider, transfersProvider, transfersDetailsProvider } from "./../../../lib/api/providers";
import {
  GET_TRANSFERS_BY_USERS,
  SET_TRANSFERS_IS_LOADING,
  SET_TRANSFERS_BY_USERS_LIST,
  GET_TRANSFERS,
  SET_TRANSFERS,
  GET_TRANSFERS_DETAILS,
  SET_TRANSFERS_DETAILS
} from "../actions/transfers";

const getLogState = state => state.log;
const getState = state => state;
const getAuthState = state => state.auth || {};

const getExpenseReadyToTransferApi = (endpoint, token, params) => {
  const filters = isEmpty(params) ? { sort: { id: -1 } } : { sort: { id: -1 }, ...params };

  return endpoint
    .post(`/`, filters, {
      headers: {
        Authorization: token
      }
    })
    .then((response = {}) => {
      return response.data;
    });
};

export function* getTransfersByUsers(action) {
  try {
    const stateAuth = yield select(getAuthState);
    const state = yield select(getLogState);
    const values = yield call(getExpenseReadyToTransferApi, transfersByUsersProvider, stateAuth.token, action.payload);

    yield put({ type: SET_TRANSFERS_IS_LOADING, payload: true });
    yield put({
      type: SET_TRANSFERS_BY_USERS_LIST,
      payload: values
    });
    yield put({ type: SET_TRANSFERS_IS_LOADING, payload: false });
  } catch (e) {
    console.log(e.message);
    yield put({ type: SET_TRANSFERS_IS_LOADING, payload: false });
  }
}

export function* getTransfers(action) {
  try {
    const stateAuth = yield select(getAuthState);
    const state = yield select(getLogState);
    const values = yield call(getExpenseReadyToTransferApi, transfersProvider, stateAuth.token, action.payload);

    yield put({ type: SET_TRANSFERS_IS_LOADING, payload: true });
    yield put({
      type: SET_TRANSFERS,
      payload: values
    });
    yield put({ type: SET_TRANSFERS_IS_LOADING, payload: false });
  } catch (e) {
    console.log(e.message);
    yield put({ type: SET_TRANSFERS_IS_LOADING, payload: false });
  }
}

export function* getTransfersDetails(action) {
  try {
    const stateAuth = yield select(getAuthState);
    const state = yield select(getLogState);
    const params = { ...action.payload, sort: { "transfer.id": -1 } };

    const values = yield call(getExpenseReadyToTransferApi, transfersDetailsProvider, stateAuth.token, params);

    yield put({ type: SET_TRANSFERS_IS_LOADING, payload: true });
    yield put({
      type: SET_TRANSFERS_DETAILS,
      payload: values
    });
    yield put({ type: SET_TRANSFERS_IS_LOADING, payload: false });
  } catch (e) {
    console.log(e.message);
    yield put({ type: SET_TRANSFERS_IS_LOADING, payload: false });
  }
}

function* watchFetchTransfersByUsers() {
  yield takeLatest(GET_TRANSFERS_BY_USERS, getTransfersByUsers);
  yield takeLatest(GET_TRANSFERS, getTransfers);
  yield takeLatest(GET_TRANSFERS_DETAILS, getTransfersDetails);
}

export default function* root() {
  yield all([fork(watchFetchTransfersByUsers)]);
}



// WEBPACK FOOTER //
// src/modules/presence/sagas/transfersSagas.js